// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-ai-connections {
  padding: 20px 0;
}

.skl-header-copy {
  margin-bottom: 20px;
}

.skl-toolbar {
  margin-bottom: 20px;
}

.skl-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.skl-card__body {
  padding: 20px;
}

.skl-table-wrap {
  border: 1px solid #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.skl-row {
  display: grid;
  grid-template-columns: 1fr 1.6fr 1fr 1fr 1fr 1.1fr;
}

.skl-row--header {
  background: #f8f9fa;
}

.skl-row--data + .skl-row--data {
  border-top: 1px solid #edf0f2;
}

.skl-cell {
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 12px 16px;
}

.skl-actions {
  display: flex;
  gap: 8px;
}

@media (max-width: 991.98px) {
  .skl-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .skl-cell {
    min-height: 48px;
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/ai-connections/ai-connections-skeleton/ai-connections-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,kDAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE;IACE,gDAAA;EACF;EAEA;IACE,gBAAA;EAAF;AACF","sourcesContent":[".skl-ai-connections {\n  padding: 20px 0;\n}\n\n.skl-header-copy {\n  margin-bottom: 20px;\n}\n\n.skl-toolbar {\n  margin-bottom: 20px;\n}\n\n.skl-card {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.skl-card__body {\n  padding: 20px;\n}\n\n.skl-table-wrap {\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.skl-row {\n  display: grid;\n  grid-template-columns: 1fr 1.6fr 1fr 1fr 1fr 1.1fr;\n}\n\n.skl-row--header {\n  background: #f8f9fa;\n}\n\n.skl-row--data + .skl-row--data {\n  border-top: 1px solid #edf0f2;\n}\n\n.skl-cell {\n  display: flex;\n  align-items: center;\n  min-height: 52px;\n  padding: 12px 16px;\n}\n\n.skl-actions {\n  display: flex;\n  gap: 8px;\n}\n\n@media (max-width: 991.98px) {\n  .skl-row {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .skl-cell {\n    min-height: 48px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
